import { AES, enc, TripleDES } from 'crypto-js';

const encryptionKey = process.env.VUE_APP_ENCRYPTION_KEY || '';

// Encrypt
const encrypt = (message: string | object) => {
  const key = process.env.VUE_APP_ENCRYPTION_KEY || '';
  let credential = message;
  if (typeof message === 'object') {
    credential = JSON.stringify(credential);
  }
  return AES.encrypt(credential as string, key).toString();
};

// Decrypt
const decrypt = (message: string) => {
  const key = process.env.VUE_APP_ENCRYPTION_KEY || '';
  const bytes = AES.decrypt(message, key);
  const decrypptData = bytes.toString(enc.Utf8);
  if (decrypptData.includes('{') && decrypptData.includes('}')) {
    return JSON.parse(decrypptData);
  }
  return decrypptData;
};

const decryptToJSON = (cipherText: string) => {
  if (!cipherText || cipherText === 'null') {
    return null;
  }
  const bytes = AES.decrypt(cipherText, encryptionKey);
  return JSON.parse(bytes.toString(enc.Utf8));
};

const decryptPlainText = (text: string) => {
  if (text == null) {
    return null;
  }
  const ciphertext = decodeURIComponent(text);
  const bytes = TripleDES.decrypt(ciphertext, encryptionKey);
  const originalText = bytes.toString(enc.Utf8);
  return originalText;
}

export { encrypt, decrypt, decryptToJSON, decryptPlainText };
